import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { FirmwareUpdateStatusStartConstraints, FirmwareUpdateStore } from '@store';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-firmware-update-start',
  templateUrl: './firmware-update-start.component.html',
  styleUrls: ['./firmware-update-start.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareUpdateStartComponent implements OnInit, OnDestroy {
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  startConstraints: FirmwareUpdateStatusStartConstraints;

  conditionsNotMetLabel: string;
  private ngUnsubscribe$ = new Subject<void>();

  constructor(
    public firmwareUpdateStore: FirmwareUpdateStore,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.checkUpdateTimeBlock();

    this.firmwareUpdateStore.firmwareUpdateStatusStartConstraints$
      .pipe(
        filter((data) => !!data),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((constraints) => {
        this.startConstraints = constraints;
        this.setConditionsNotMetLabel(constraints);
      });
  }

  checkUpdateTimeBlock(): void {
    this.firmwareUpdateStore.checkUpdateTimeBlock();
  }

  checkUpdateVerification(): void {
    this.firmwareUpdateStore.checkUpdateVerification();
  }

  onCancel(): void {
    this.cancel.emit();
  }

  private setConditionsNotMetLabel(constraints: FirmwareUpdateStatusStartConstraints): void {
    if (constraints.canProceed) {
      return;
    }

    if (!constraints.isSoftwareCorrect) {
      this.conditionsNotMetLabel = this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.SOFTWARE_VERSION_ERROR_DESCRIPTION'
      );

      return;
    }

    if (!constraints.isGatewayAllowed) {
      this.conditionsNotMetLabel = this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.GATEWAY_VERIFICATION_ERROR_DESCRIPTION'
      );

      return;
    }

    if (!constraints.isEveryRequestSuccessful) {
      this.conditionsNotMetLabel = this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.GENERAL_ERROR_DESCRIPTION'
      );
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
